import { Button } from "react-bootstrap";
import { ChevronRightIcon } from "@heroicons/react/outline";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const AgendaCourseCard = ({
	event
}) => (
	<>
		<h5 className="text-blue">
			Category Name
		</h5>

		<h4>
			<Link className="text-dark" to={`/class/${event.id}`}>
				{event.title}
			</Link>
		</h4>

		<p>
			{event.description}
		</p>

		<Button as={Link} to={`/class/${event.id}`} variant="link">
			Find Out More <ChevronRightIcon className="i" />
		</Button>
	</>
);

AgendaCourseCard.propTypes = {
	event: PropTypes.shape({
		description: PropTypes.string,
		id: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired
	}).isRequired
};

export default AgendaCourseCard;
